// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Card,
//   CardContent,
//   IconButton,
//   Tooltip,
//   Stack,
// } from "@mui/material";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ZoomInIcon from "@mui/icons-material/ZoomIn";
// import ZoomOutIcon from "@mui/icons-material/ZoomOut";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
// import { API_BASE_URL } from "../../config";

// const API_URL = `${API_BASE_URL}/auth/orgchart/`;

// // Layout constants (tweak if you change card width or spacing)
// const CARD_WIDTH = 180; // must match Card width in styles below
// const H_GAP = 50; // horizontal gap between cards
// const CENTER_SPACING = CARD_WIDTH + H_GAP; // distance between centers of adjacent cards

// const OrgNode = ({ node }) => {
//   const [expanded, setExpanded] = useState(false);

//   const toggleExpand = (e) => {
//     e?.stopPropagation?.();
//     if (node.subordinates?.length) setExpanded((s) => !s);
//   };

//   const children = node.subordinates || [];
//   const childCount = children.length;

//   const childrenSpan = childCount > 1 ? (childCount - 1) * CENTER_SPACING : 0;
//   const lineLeftOffset =
//     childCount > 0 ? `calc(50% - ${childrenSpan / 2}px)` : "50%";
//   const lineWidth = childCount > 1 ? `${childrenSpan}px` : "0px";

//   return (
//     <Box
//       onClick={toggleExpand}
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         position: "relative",
//         cursor: node.subordinates?.length ? "pointer" : "default",
//         userSelect: "none",
//       }}
//     >
//       {/* Card */}
//       <Card
//         sx={{
//           width: `${CARD_WIDTH}px`,
//           textAlign: "center",
//           borderRadius: 2,
//           borderTop:
//             node.level === 0
//               ? "4px solid #a259ff"
//               : node.level === 1
//               ? "4px solid #03a9f4"
//               : "4px solid #00bcd4",
//           boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
//           backgroundColor: "#fff",
//           transition: "transform 0.16s ease",
//           "&:hover": {
//             transform: node.subordinates?.length ? "scale(1.02)" : "none",
//           },
//         }}
//       >
//         <CardContent sx={{ pb: 1 }}>
//           <Avatar
//             src={node.profile_img || ""}
//             alt={node.name}
//             sx={{
//               width: 60,
//               height: 60,
//               margin: "0 auto 8px",
//               backgroundColor: "#d9d9d9",
//               fontSize: 20,
//               fontWeight: 700,
//             }}
//           >
//             {!node.profile_img && (node.name?.charAt(0) || "U")}
//           </Avatar>

//           <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
//             {node.name}
//           </Typography>
//           <Typography variant="body2" sx={{ color: "#777", mt: 0.4 }}>
//             {node.designation}
//           </Typography>

//           <Box
//             sx={{
//               mt: 1,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: 0.5,
//             }}
//           >
//             {node.linkedin_profile && (
//               <Tooltip title="LinkedIn">
//                 <IconButton
//                   size="small"
//                   href={node.linkedin_profile}
//                   target="_blank"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <LinkedInIcon fontSize="small" color="primary" />
//                 </IconButton>
//               </Tooltip>
//             )}

//             {node.subordinates?.length > 0 && (
//               <IconButton
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setExpanded((s) => !s);
//                 }}
//                 aria-label={expanded ? "collapse" : "expand"}
//               >
//                 <ExpandMoreIcon
//                   sx={{
//                     transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
//                     transition: "transform 0.25s ease",
//                     color: "#555",
//                   }}
//                 />
//               </IconButton>
//             )}
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Vertical connector */}
//       {childCount > 0 && expanded && (
//         <Box
//           sx={{
//             width: "2px",
//             height: 24,
//             backgroundColor: "#d8d8d8",
//             mt: 1,
//           }}
//         />
//       )}

//       {/* Children row */}
//       {childCount > 0 && expanded && (
//         <Box
//           sx={{
//             position: "relative",
//             mt: 1.5,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-start",
//             px: 0,
//             width: "100%",
//           }}
//         >
//           {/* Horizontal connector */}
//           {childCount > 1 ? (
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: -16,
//                 left: lineLeftOffset,
//                 height: "2px",
//                 width: lineWidth,
//                 backgroundColor: "#d8d8d8",
//                 zIndex: 0,
//                 borderRadius: "1px",
//               }}
//             />
//           ) : (
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: -16,
//                 left: `calc(50% - 12px)`,
//                 height: "2px",
//                 width: "24px",
//                 backgroundColor: "#d8d8d8",
//                 zIndex: 0,
//                 borderRadius: "1px",
//               }}
//             />
//           )}

//           {/* Each child */}
//           {children.map((child) => (
//             <Box
//               key={child.id}
//               sx={{
//                 position: "relative",
//                 mx: `${H_GAP / 2}px`,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 zIndex: 1,
//               }}
//             >
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: -16,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "2px",
//                   height: "18px",
//                   backgroundColor: "#d8d8d8",
//                 }}
//               />
//               <OrgNode node={{ ...child, level: (node.level || 0) + 1 }} />
//             </Box>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// };

// const OrgChart = () => {
//   const [orgData, setOrgData] = useState([]);
//   const [zoom, setZoom] = useState(1);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         setOrgData(Array.isArray(res.data) ? res.data : [res.data]);
//       } catch (err) {
//         console.error("Error fetching org chart:", err);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleZoomIn = () => setZoom((z) => Math.min(z + 0.1, 2));
//   const handleZoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
//   const handleResetZoom = () => setZoom(1);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         p: 4,
//         overflowX: "auto",
//         overflowY: "visible",
//         minHeight: "80vh",
//         background: "#fff",
//         width: "100%",
//         position: "relative",
//       }}
//     >
//       {/* Title */}
//       <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, color: "#333" }}>
//         Organizational Chart
//       </Typography>

//       {/* Zoom controls */}
//       <Stack
//         direction="row"
//         spacing={1}
//         sx={{
//           mb: 2,
//           position: "sticky",
//           top: 16,
//           backgroundColor: "#fff",
//           zIndex: 10,
//           borderRadius: "8px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//           p: 0.5,
//         }}
//       >
//         <Tooltip title="Zoom In">
//           <IconButton onClick={handleZoomIn}>
//             <ZoomInIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Zoom Out">
//           <IconButton onClick={handleZoomOut}>
//             <ZoomOutIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Reset Zoom">
//           <IconButton onClick={handleResetZoom}>
//             <RestartAltIcon />
//           </IconButton>
//         </Tooltip>
//       </Stack>

//       {/* Chart container */}
//       <Box
//         sx={{
//           display: "inline-flex",
//           justifyContent: "center",
//           position: "relative",
//           minWidth: "max-content",
//           transform: `scale(${zoom})`,
//           transformOrigin: "top center",
//           transition: "transform 0.2s ease-in-out",
//         }}
//       >
//         {orgData.map((root) => (
//           <OrgNode key={root.id} node={{ ...root, level: 0 }} />
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default OrgChart;



import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { API_BASE_URL } from "../../config";

const API_URL = `${API_BASE_URL}/auth/orgchart/`;

// Layout constants
const CARD_WIDTH = 180;
const H_GAP = 50;
const CENTER_SPACING = CARD_WIDTH + H_GAP;

const OrgNode = ({ node }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = (e) => {
    e?.stopPropagation?.();
    if (node.subordinates?.length) setExpanded((s) => !s);
  };

  const children = node.subordinates || [];
  const childCount = children.length;

  const childrenSpan = childCount > 1 ? (childCount - 1) * CENTER_SPACING : 0;
  const lineLeftOffset =
    childCount > 0 ? `calc(50% - ${childrenSpan / 2}px)` : "50%";
  const lineWidth = childCount > 1 ? `${childrenSpan}px` : "0px";

  return (
    <Box
      onClick={toggleExpand}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        cursor: node.subordinates?.length ? "pointer" : "default",
        userSelect: "none",
        minWidth: "max-content", // Ensure node doesn't shrink
      }}
    >
      {/* Card */}
      <Card
        sx={{
          width: `${CARD_WIDTH}px`,
          textAlign: "center",
          borderRadius: 2,
          borderTop:
            node.level === 0
              ? "4px solid #a259ff"
              : node.level === 1
              ? "4px solid #03a9f4"
              : "4px solid #00bcd4",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
          backgroundColor: "#fff",
          transition: "transform 0.16s ease",
          flexShrink: 0, // Prevent card from shrinking
          "&:hover": {
            transform: node.subordinates?.length ? "scale(1.02)" : "none",
          },
        }}
      >
        <CardContent sx={{ pb: 1 }}>
          <Avatar
            src={node.profile_img || ""}
            alt={node.name}
            sx={{
              width: 60,
              height: 60,
              margin: "0 auto 8px",
              backgroundColor: "#d9d9d9",
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            {!node.profile_img && (node.name?.charAt(0) || "U")}
          </Avatar>

          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {node.name}
          </Typography>
          <Typography variant="body2" sx={{ color: "#777", mt: 0.4 }}>
            {node.designation}
          </Typography>

          <Box
            sx={{
              mt: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {node.linkedin_profile && (
              <Tooltip title="LinkedIn">
                <IconButton
                  size="small"
                  href={node.linkedin_profile}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                >
                  <LinkedInIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
            )}

            {node.subordinates?.length > 0 && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded((s) => !s);
                }}
                aria-label={expanded ? "collapse" : "expand"}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.25s ease",
                    color: "#555",
                  }}
                />
              </IconButton>
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Vertical connector */}
      {childCount > 0 && expanded && (
        <Box
          sx={{
            width: "2px",
            height: 24,
            backgroundColor: "#d8d8d8",
            mt: 1,
          }}
        />
      )}

      {/* Children row */}
      {childCount > 0 && expanded && (
        <Box
          sx={{
            position: "relative",
            mt: 1.5,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            px: 0,
            width: "max-content", // Ensure children row doesn't wrap
            minWidth: "100%", // Ensure it takes full available width
          }}
        >
          {/* Horizontal connector */}
          {childCount > 1 ? (
            <Box
              sx={{
                position: "absolute",
                top: -16,
                left: lineLeftOffset,
                height: "2px",
                width: lineWidth,
                backgroundColor: "#d8d8d8",
                zIndex: 0,
                borderRadius: "1px",
              }}
            />
          ) : (
            <Box
              sx={{
                position: "absolute",
                top: -16,
                left: `calc(50% - 12px)`,
                height: "2px",
                width: "24px",
                backgroundColor: "#d8d8d8",
                zIndex: 0,
                borderRadius: "1px",
              }}
            />
          )}

          {/* Each child */}
          {children.map((child) => (
            <Box
              key={child.id}
              sx={{
                position: "relative",
                mx: `${H_GAP / 2}px`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
                flexShrink: 0, // Prevent child containers from shrinking
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: -16,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "2px",
                  height: "18px",
                  backgroundColor: "#d8d8d8",
                }}
              />
              <OrgNode node={{ ...child, level: (node.level || 0) + 1 }} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

const OrgChart = () => {
  const [orgData, setOrgData] = useState([]);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(API_URL);
        setOrgData(Array.isArray(res.data) ? res.data : [res.data]);
      } catch (err) {
        console.error("Error fetching org chart:", err);
      }
    };
    fetchData();
  }, []);

  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.1, 2));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
  const handleResetZoom = () => setZoom(1);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 4,
        width: "95%",
        height: "100vh",
        overflow: "hidden",
        background: "#fff",
        position: "relative",
          mt:10,
      }}
    >
      {/* Title */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, color: "#333" }}>
        Organizational Chart
      </Typography>

      {/* Zoom controls */}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mb: 2,
          position: "sticky",
          top: 16,
          backgroundColor: "#fff",
          zIndex: 10,
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          p: 0.5,
        }}
      >
        <Tooltip title="Zoom In">
          <IconButton onClick={handleZoomIn}>
            <ZoomInIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Zoom Out">
          <IconButton onClick={handleZoomOut}>
            <ZoomOutIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Reset Zoom">
          <IconButton onClick={handleResetZoom}>
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      {/* Main chart container with proper scrolling */}
      <Box
        sx={{
          width: "100%",
          flex: 1,
          overflow: "auto",
          border: "1px solid #f0f0f0",
          borderRadius: 1,
          backgroundColor: "#fafafa",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            minHeight: "100%",
            minWidth: "max-content", // Ensure container expands to fit content
            p: 4,
          }}
        >
          {/* Zoom container */}
          <Box
            sx={{
              display: "inline-flex",
              justifyContent: "center",
              position: "relative",
              minWidth: "max-content",
              transform: `scale(${zoom})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            {orgData.map((root) => (
              <OrgNode key={root.id} node={{ ...root, level: 0 }} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OrgChart;